module.exports = __webpack_public_path__ + "img/pure-escape.40f8c798.jpg";